import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import {dateFormat} from "../../utilities/dateFormat";
import makeNameFromPersona from "../../utilities/makeNameFromPersona";
import ReactTable from "../conteiners/ReactTable";
import useColumns from "../Requests/OrderProcessing/utils/hooks/useColumns";
import {expandedTextArray} from "../Requests/RequestsInProgress/utils/functions/expandDataForTable";

import {APPEAL_LIST_TABLE_COLUMNS} from "./constants";
import {clearCurrentTicket, selectAllDevITTickets, selectDevITLoading} from "./DevITSlice";

const DevITBodyTable = ({currentTicketId, setCurrentTicketId, onPaginate, page}) => {
  const dispatch = useDispatch();
  const {
    i18n: {language},
  } = useTranslation();
  const loading = useSelector(selectDevITLoading);
  const allTickets = useSelector(selectAllDevITTickets);
  const ticketsTableColumns = useColumns(APPEAL_LIST_TABLE_COLUMNS);
  const onTicketsTableSelect = ticketId => {
    setCurrentTicketId(ticketId);
    if (!ticketId) {
      dispatch(clearCurrentTicket());
      setCurrentTicketId(null);
    }
  };

  const ticketsTableData = useMemo(() => {
    return (
      allTickets
        ?.filter(Boolean)
        ?.map(
          (
            {
              ticketId,
              type: {nameEng: typeNameEng, nameUkr: typeNameUkr},
              block: {nameEng: blockNameEng, nameUkr: blockNameUkr},
              status: {nameEng: statusNameEng, nameUkr: statusNameUkr},
              creator: {persona},
              text,
              note,
              startDate,
              finishDate,
              createdAt,
              tasks,
              files,
            },
            index,
          ) => ({
            number: ++index,
            id: ticketId,
            date: dateFormat(createdAt),
            appealType: language === "en" ? typeNameEng : typeNameUkr,
            isFileAdded: files?.length > 0,
            about: text,
            block: language === "en" ? blockNameEng : blockNameUkr,
            manager: makeNameFromPersona({language, persona}),
            status: language === "en" ? statusNameEng : statusNameUkr,
            managerIT: expandedTextArray(
              tasks?.reduce(
                (acc, task) => [...acc, makeNameFromPersona({persona: task.performer.persona, language})],
                [],
              ),
            ),
            startDate: dateFormat(startDate) ?? "-",
            planDate: tasks?.[0] ? dateFormat(tasks?.[0]?.deadline) ?? "-" : "-",
            finishDate: dateFormat(finishDate) ?? "-",
            isDone: Boolean(finishDate),
            noteIT: note ?? "-",
          }),
        ) ?? []
    );
  }, [JSON.stringify(allTickets)]);
  return (
    <ReactTable
      columns={ticketsTableColumns}
      defaultData={ticketsTableData}
      onSelect={onTicketsTableSelect}
      className="fGrow scrollX scrollY fShrink"
      current={currentTicketId}
      loading={loading}
      style={{height: "19rem"}}
      onPaginate={onPaginate}
      paginatable
      currentPage={page?.currentPage}
      paginationPageView
      totalPages={page?.totalPages}
    />
  );
};

export const DevItTable = React.memo(DevITBodyTable);
